<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner5.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <div class="title">产品与服务</div>
                    <ul>
                        <!-- <li><a href="javascript:void(0);" @click.stop="goTo('WuLianWangChanPin')">物联网产品</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('JiFangHuanJingZiDongJianKongXiTong')">机房环境自动监控系统</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('XinFangYiTiJi')">信访一体机</a></li> -->
                        <li><a href="javascript:void(0);" @click.stop="goTo('RuanJianChanPin')">软件产品</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YingJianChanPin')">硬件产品</a></li>
                        <!-- <li><a href="javascript:void(0);" @click.stop="goTo('ZhiNengShuiBiao')">智能水表</a></li> -->
                        <li><a href="javascript:void(0);" @click.stop="goTo('CeShiPingTai')">测试平台</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YunWeiFuWu')">运维服务</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheMiYeWuFuWu')">涉密业务服务</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ article.title }}</h2>
                    <div class="product_view">
                        <div style="margin:0px 30px;display:none;"><img :src="img_address+article.contentImg" :onerror="defaultImg" style="margin:0px auto;width:10%;" /></div>
                        <div class="main_content" v-html="article.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ChanPinZhongXin } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '产品中心',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            id: this.$route.query.id, //传入的id
            contentType : this.$route.query.contentType, //传入的contentType

            img_address:'http://www.corner.com.cn',

            defaultImg: 'this.src="' + require('../assets/img/default.jpg') + '"',


            article: {
                title:'',
                datetime:'',
                content:''
            },
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.ChanPinZhongXin_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        ChanPinZhongXin_data(){ //文章分类显示
            ChanPinZhongXin({
                contentType : this.contentType,
                id: this.id,
            }).then((res) => {
                console.log( res );
               
                this.article.title = res.rows[0].contentTitle;
                this.article.datetime = res.rows[0].createTime;

                this.article.contentImg = res.rows[0].contentImg;
                this.article.content = res.rows[0].contentDetails;
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ProductView.vue